<template>
  <div class="start-point-section">
    <label
      class="start-point"
      :class="{ selected: localSelectedOption === 'Serve', 'input-disabled': isDisabled }"
    >
      <input type="radio" value="Serve" v-model="localSelectedOption" :disabled="disabled" />
      Serve
    </label>
    <label
      class="start-point"
      :class="{ selected: localSelectedOption === 'Receive', 'input-disabled': isDisabled }"
    >
      <input type="radio" value="Receive" v-model="localSelectedOption" :disabled="disabled" />
      Receive
    </label>
  </div>
</template>

<script>
export default {
  props: {
    currentStartPoint: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localSelectedOption: this.currentStartPoint
    };
  },
  computed: {
    isDisabled() {
      return this.disabled;
    }
  },
  watch: {
    currentStartPoint: {
      immediate: true,
      handler(newOption) {
        this.localSelectedOption = newOption;
      }
    },
    localSelectedOption(newOption) {
      this.$emit('update-first-set', 'startPoint', newOption);
      this.$emit('update-selected-option', newOption);
    }
  }
};
</script>

<style scoped lang="scss">
.start-point-section {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 3vw;
  margin: 0;
  width: 100%;
  container-type: inline-size;

  .start-point {
    padding: 15px 25px;
    background: linear-gradient(0deg, var(--grey-50), var(--grey-200));
    color: var(--grey-900);
    display: inline-flex;
    border-radius: 5px;
    width: 40%;
    aspect-ratio: 3 / 2;
    max-width: 500px;
    gap: 10px;
    font-size: 4cqi; 
    cursor: pointer;
    border-radius: 20px;
    font-weight: 700;
    box-shadow: 0 3px var(--grey-800), 0 -2px var(--grey-5);
    transition: all 0.05s ease-in-out;
    text-shadow: 0 -1px var(--grey-1000), 0 1.5px var(--grey-10);
    justify-content: flex-start;
    align-items: flex-start;

    &:last-child {
      justify-content: flex-end;
      align-items: flex-end;
    }

    &:hover {
      background: linear-gradient(0deg, var(--grey-10), var(--grey-100));
      color: var(--grey-700);
    }

    &:active {
      scale: 0.99;
    }

    input {
      display: none;
    }

    &.input-disabled {
      cursor: default;
      opacity: 1;
    }

    &.selected {
      background: var(--grey-900);
      color: var(--white);
      font-weight: bold;

      .player-role {
        color: var(--white);
      }
    }

    &.error {
      background: var(--red-50);

      &.selected {
        background: var(--grey-900);
        color: var(--white);
      }
    }
  }
}
</style>
